jQuery(document).ready(function( $ ){
	// START JQUERY
  logit = (typeof logit !== 'undefined')? logit : false;
	main_navbar = (typeof main_navbar !== 'undefined')? main_navbar :  'mainNavbar';
	main_nav = (typeof main_nav !== 'undefined')? main_nav :  'mainNav';

//	affix_enable =  true;

//	affix_class =  'affix';
//	affix_top = 'affix-top';
//	affix_navbar_main =  main_navbar; // main nav
//	affix_navbar_height =  false = auto or px value


	affix_enable = (typeof affix_enable !== 'undefined')? affix_enable : false;
	affix_class = (typeof affix_class !== 'undefined')? affix_class : 'affix';
	affix_top = (typeof affix_top !== 'undefined')? affix_top : 'affix-top';

	affix_navbar_main = (typeof affix_navbar_main !== 'undefined')? affix_navbar_main : main_navbar; // main nav
	affix_navbar_height = (typeof affix_navbar_height !== 'undefined')? affix_navbar_height : 0; // false = auto or px value

	var affix_navbar_main_selector = '#' + affix_navbar_main;

	// set navbar height
	if(affix_navbar_main_selector && !affix_navbar_height) {
		if($(affix_navbar_main_selector).length) {
			affix_navbar_height = $(affix_navbar_main_selector).outerHeight();
			if(logit == 2) console.log('[STICKY] Affix selector: ' + affix_navbar_main_selector + ' height: ' + affix_navbar_height);
		}
	}

	if (affix_enable) {
		if(logit) console.log('[STICKY] Affix enabled!');

			function checkNavTop(el,off) {
				var top = $(window).scrollTop();
				if (top >= off) {
					if(logit == 3) console.log('[STICKY] Affix down');
					$(el).addClass(affix_class);
					$(el).removeClass(affix_top);
				} else {
					if(logit == 3) console.log('[STICKY] Affix ontop');
					$(el).removeClass(affix_class);
					$(el).addClass(affix_top);
				}
			}

			$(window).scroll(function(){
				if(logit == 3) console.log('[STICKY] Affix refreshed on scroll');
				checkNavTop(affix_navbar_main_selector,affix_navbar_height);
			});

			$(window).on('load', function(){
				if(logit == 3) console.log('[STICKY] Affix refreshed on load');
				checkNavTop(affix_navbar_main_selector,affix_navbar_height);
			});
	} else {
	  if(logit == 3) console.log('[STICKY] Affix disabled');
	}

// END JQUERY
});
